export const partnerPage = {
    "meta": {
        "title": "DMARCflow Partnerprogramm",
        "description": "Verdiene passives Einkommen, indem du die E-Mails deiner Kunden in nur 3 Minuten mit DMARCflow absicherst.",
        "ogTitle": "Werde Teil des DMARCflow Partnerprogramms",
        "ogDescription": "Hilf Kunden, ihre E-Mails zu schützen, und erhalte wiederkehrende Provisionen – ganz ohne DNS-Vorkenntnisse."
    },
    "hero": {
        "headline": "Verdiene passives Einkommen, indem du die E-Mails deiner Kunden in 3 Minuten absicherst",
        "description": "Analysiere jede Domain auf DMARC-Konformität, zeige sofortige Schwachstellen und biete ein Upgrade für nur 1 €/Monat mit DMARCflow an. Keine technischen Kenntnisse oder DNS-Erfahrung erforderlich.",
        "cta": "Jetzt Partner werden"
    },
    "scanner": {
        "title": "Prüfe die Domain deines Kunden auf E-Mail-Schwachstellen",
        "description": "Analysiere die Domain deines Kunden auf DMARC-, SPF- und DKIM-E-Mail-Authentifizierung.",
        "hint1": "Erkenne sofort, ob eine Domain anfällig für Spoofing, Phishing oder Zustellprobleme ist – und verdiene Geld, indem du sie absicherst.",
        "hint2": "Keine Anmeldung erforderlich – klare Ergebnisse in Sekunden."
    },
    "howItWorks": {
        "title": "So funktioniert’s",
        "description": "Mit uns zusammenzuarbeiten ist ganz einfach – nutze einfach diese Tools:",
        "steps": [
            {
                "title": "Scannen",
                "desc": "Nutze unser Tool, um Domains sofort auf fehlende DMARC-, SPF- oder DKIM-Einträge zu analysieren."
            },
            {
                "title": "Bericht",
                "desc": "Ein klarer, leicht verständlicher DMARC-Bericht wird generiert – ganz ohne Fachchinesisch."
            },
            {
                "title": "Teilen",
                "desc": "Teile den Bericht und empfehle die Lösung für €x/Monat mit deinem persönlichen Partnerlink."
            },
            {
                "title": "Verdienen",
                "desc": "Dein Kunde erhält sichere E-Mail-Zustellung – du erhältst monatlich wiederkehrende Einnahmen."
            }
        ]
    },
    "benefits": {
        "title": "Warum Partner DMARCflow lieben",
        "description": "Wiederkehrendes Einkommen verdienen und gleichzeitig die Sicherheit deiner Kunden verbessern",
        "points": [
            "Keine DNS- oder Technikkenntnisse nötig – ideal für Marketer, Freelancer, VAs oder Agenturen.",
            "Kunden achten auf Zustellbarkeit – ohne DMARC landen ihre E-Mails im Spam.",
            "Du wirst wertvoller – biete echte Sicherheit als Teil deiner Dienstleistungen.",
            "Niedrige Einstiegshürde mit dem 1 €/Monat-Tarif – einfache Preisstruktur, der Kunden zustimmen."
        ],
        "commission": {
            "title": "Partnerprovisionen & Auszahlungen",
            "description": "Erhalte 10 % bis 30 % monatliche Provisionen – oder wähle eine einmalige Auszahlung. Dein Einkommen wächst mit deiner Kundenanzahl.",
            "tiersTitle": "Provisionsstufen",
            "tiers": [
                "✅ 10 % für 1–10 aktive Kunden",
                "✅ 20 % für 11–50 Kunden",
                "✅ 30 % für 51+ Kunden"
            ],
            "footer": "💸 Monatliche Auszahlungen über Stripe oder PayPal. Du hast Zugriff auf ein Partner-Dashboard mit Echtzeitstatistiken."
        }
    },
    "cta": {
        "title": "Starte noch heute mit dem DMARCflow Partnerprogramm",
        "description": "Bereit für eine neue Einnahmequelle und bessere E-Mail-Sicherheit für deine Kunden – ganz ohne Technikstress?",
        "button": "Jetzt kostenlos mitmachen"
    },
    "faq": {
        "title": "Alles, was du wissen musst",
        description: "Du hast Fragen? Wir haben Antworten!",
        "questions": [
            {
                "q": "Wie kann ich meine Einnahmen und Kunden verfolgen?",
                "a": "Nutze dein Partner-Dashboard, um Provisionen, Kundenempfehlungen und Auszahlungsverlauf einzusehen."
            },
            {
                "q": "Ist die Teilnahme am Partnerprogramm kostenlos?",
                "a": "Ja — es ist zu 100 % kostenlos. Du verdienst Geld, ohne etwas zu bezahlen."
            },
            {
                "q": "Welche Unterstützung erhalte ich als Partner?",
                "a": "Wir stellen Vorlagen, Onboarding-Guides, Live-Chat und E-Mail-Support bereit."
            },
            {
                "q": "Wann werde ich bezahlt?",
                "a": "Auszahlungen erfolgen zu Beginn eines jeden Monats für die Einnahmen des Vormonats."
            },
            {
                "q": "Kann ich DMARCflow unter meiner eigenen Marke anbieten?",
                "a": "Absolut. Verwende unsere Vorlagen und Materialien, um DMARCflow als Teil deiner Dienstleistung zu präsentieren."
            }
        ]
    }
}
